/* eslint-disable no-param-reassign */
import axios from "axios";

class Geocoder {
  constructor(RegionService) {
    this.defaults = {
      f: "json",
      searchclass: "OSM,RDI,ADD,VAL,PAR,BUS,RDC",
      searchextent: RegionService.searchExtentRest,
      searchextenttype: "WGS84",
      searchlimit: 200,
      searchterm: ""
    };

    this.RegionService = RegionService;
  }

  stripOutSuburb(address) {
    if (address == null) {
      throw new Error("No address provided");
    }

    let suburb = this.RegionService.defaultSuburb;
    if (address.match(/\[/)) {
      const bits = address.split(/\[/);
      if (bits.length === 2) {
        address = bits[0].replace(/^\s+|\s+$/, "");
        suburb = bits[1].replace("]", "").replace(/^\s+|\s+$/, "");
      }
    }

    return {
      address,
      suburb
    };
  }

  async geocode(address) {
    // strip any HTML tags and then encode the remaining string
    this.defaults.searchterm = address.replace(/(<([^>]+)>)/gi, "");

    try {
      const results = await this.fetchData();
      const { data } = results;

      if (!data || data[0].value.keydescription === "No Matching results") {
        throw Error("No results");
      }

      // Slightly normalize to Google API style
      return data.map(i => {
        // console.log(i);
        const item = i;
        // The REST Geocoder returns plenty of whitespace
        item.label = item.label.trim();

        // remove any ", Christchurch City" provided by the REST Geocoder, for compatibility with the ESRI Geocoder
        const remove = ", Christchurch City";
        if (item.label.substr(-remove.length) === remove) {
          item.label = item.label.substr(0, item.label.length - remove.length);
        }

        // strip out suburbs if provided
        const result = this.stripOutSuburb(item.label);
        item.address = result.address;
        item.formatted_address =
          result.address + (result.suburb ? `, ${result.suburb}` : "");
        item.suburb = result.suburb;

        item.id = item.label;
        // the REST Geocoder gets these in the wrong order
        item.lat = item.value.longitude;
        item.lng = item.value.latitude;
        item.text = item.formatted_address;
        return item;
      });
    } catch (error) {
      return false;
    }
  }

  fetchData() {
    const url = "/api/journey";

    const options = {
      url,
      method: "GET",
      params: this.defaults,
      responseType: "json"
    };

    try {
      const data = axios(options);
      return data;
    } catch (error) {
      console.error(error);
      return false;
    }
  }
}

export default Geocoder;
